import React, {useMemo} from 'react';
import {FormGroup, NumericInput} from '@blueprintjs/core';

interface NumberInputProps {
  value: string;
  disabled: boolean;
  onChange: (value: any) => void;
}

function isNumeric(number: any) {
  return !isNaN(parseFloat(number));
}

export const NumberInput = ({value, disabled, onChange}: NumberInputProps) => {
  const defaultValue = useMemo(() => isNumeric(value) ? parseFloat(value) : 0, [value]);

  return (
    <FormGroup label="">
      <NumericInput
        disabled={disabled}
        defaultValue={defaultValue}
        onValueChange={onChange}
        fill={true}
      />
    </FormGroup>
  );
};
